import { Result } from "antd";
import clsx from "clsx";
import RutterLogo from "../assets/logo.svg";

export type IntroductionHeaderProps = {
  title: string | React.ReactNode;
  description?: string;
  success?: boolean;
  sourceLogo?: string;
  destinationLogo?: string;
};

export const IntroductionHeader: React.FC<IntroductionHeaderProps> = ({
  title,
  description,
  success,
  sourceLogo = RutterLogo,
  destinationLogo,
}) => {
  const ImageContainer: React.FC = ({ children }) => (
    <div className="p-2 rounded-md border-2">{children}</div>
  );

  return (
    <>
      {success ? (
        <Result status="success" className="p-0" />
      ) : (
        <div className="flex justify-center items-center gap-3 mb-[16px] mt-[24px]">
          <ImageContainer>
            <img
              src={sourceLogo}
              alt="Source Connection"
              className="w-5 sm:w-7 h-5 sm:h-7 max-w-[60px] max-h-[60px]"
            />
          </ImageContainer>
          {destinationLogo && (
            <>
              <div className="flex gap-[3px]">
                <div className="w-[4px] sm:w-[5px] h-[4px] sm:h-[5px] rounded-full bg-slate-300" />
                <div className="w-[4px] sm:w-[5px] h-[4px] sm:h-[5px] rounded-full bg-slate-300" />
                <div className="w-[4px] sm:w-[5px] h-[4px] sm:h-[5px] rounded-full bg-slate-300" />
              </div>
              <ImageContainer>
                <img
                  src={destinationLogo}
                  alt="Destination Connection"
                  className="w-5 sm:w-7 h-5 sm:h-7 max-w-[60px] max-h-[60px]"
                />
              </ImageContainer>
            </>
          )}
        </div>
      )}

      <h1
        className={clsx(
          "text-lg sm:text-xl font-bold text-[#212430] text-center leading-6 sm:leading-7 px-4",
          {
            "mb-[8px]": description,
            "mb-[24px]": !description,
          },
        )}
      >
        {title}
      </h1>
      {description && (
        <h2 className="text-slate-500 text-center text-xs sm:text-sm mb-[32px]">
          {description}
        </h2>
      )}
    </>
  );
};
